<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

    page: {
        title: 'Новый оператор',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader },

    data() {
        return {
            title: 'Новый оператор',
            items: [],
            operator_uuid: '',
            name: '',
            code: ''
        }
    },

    computed: {
        operator_item(){
            return this.$store.getters['operators/GET_OPERATORS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {
        this.operator_uuid = this.$route.params.operator_uuid ? this.$route.params.operator_uuid : '';
        if(this.operator_uuid !== ''){

            this.title = 'Изменение информации об операторе';
            document.title = appConfig.title + ' - ' + 'Изменение информации об операторе';

            let data_send = {
                'uuid' : this.operator_uuid
            }

            await this.$store.dispatch('operators/FETCH_OPERATORS_ITEM', data_send);

            this.name = this.operator_item.name ? this.operator_item.name : '';
            this.code = this.operator_item.code ? this.operator_item.code : '';
        }
    },

    methods: {

        async saveItem(){

            let data_send = {
                'name' : this.name,
                'code' : this.code
            };

            let result = '';

            if(this.operator_uuid === ''){
                result = await this.$store.dispatch('operators/FETCH_OPERATORS_CREATE', data_send);
            } else {
                data_send.uuid = this.operator_uuid;
                result = await this.$store.dispatch('operators/FETCH_OPERATORS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Operators'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder="Укажите символьный код оператора"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название оператора"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название оператора"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
